import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-info",
  "use": "icon-si-glyph-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-info\" id=\"icon-si-glyph-info\"><title>117</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(4.000000, 0.000000)\" fill=\"#434343\"><ellipse cx=\"4.486\" cy=\"1.525\" rx=\"1.486\" ry=\"1.525\" class=\"si-glyph-fill\" /><path d=\"M4.479,13.325 L5.852,4.703 C5.852,4.703 5.881,4.004 5.216,4.004 C3.715,4.004 -0.074,4.008 -0.074,4.008 C-0.074,4.008 3.905,4.721 3.905,6.067 C3.905,6.067 2.597,11.827 2.597,13.357 C2.597,14.888 3.433,16.001 4.934,16.001 C6.159,16.001 7.272,14.665 7.188,12.718 C5.991,14.554 4.479,14.82 4.479,13.325 L4.479,13.325 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-info.svg
// module id = FyQQ
// module chunks = 62